import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const stories = [{
  discipline: 'ENTRENAMIENTO FUNCIONAL',
  quote: '“En las primeras dos semanas activé los guiones de WhatsApp y cerré 3 alumnos nuevos que estaban fríos hace meses.”',
  name: 'Marcos D. — Buenos Aires',
  result: '+3 alumnos en 14 días'
}, {
  discipline: 'BOXEO',
  quote: '“Nunca había pensado en usar Instagram así. Empecé con el módulo 2 y en un mes tuve clientes orgánicos sin pagar nada.”',
  name: 'Valentina R. — Córdoba',
  result: 'Clientes orgánicos en 30 días'
}, {
  discipline: 'CROSSFIT & FUERZA',
  quote: '“El plan de 90 días me dio estructura. Antes improvisaba todo. Ahora sé exactamente qué hacer cada semana.”',
  name: 'Diego F. — Rosario',
  result: 'Sistema activo en 90 días'
}];
type TestimonialCardsProps = {
  compact?: boolean;
};
export function TestimonialCards({
  compact = false
}: TestimonialCardsProps) {
  return <div className="grid gap-4 lg:grid-cols-3" data-id="element-158">
      {stories.map((story, index) => <Reveal key={story.name} delay={index * 0.05} data-id="element-159">
          <figure className={`premium-card flex h-full flex-col bg-card ${compact ? 'p-5' : 'p-7'}`} data-id="element-160">
            <div className="flex items-center justify-between gap-3" data-id="element-161">
              <p className="font-mono text-[9px] font-semibold tracking-[0.13em] text-gold" data-id="element-162">
                {story.discipline}
              </p>
              <div className="flex gap-0.5" aria-label="5 estrellas" data-id="element-163">
                {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} size={12} className="fill-gold text-gold" aria-hidden="true" data-id="element-164" />)}
              </div>
            </div>
            <blockquote className={`flex-1 text-ivory ${compact ? 'mt-5 text-sm leading-6' : 'mt-7 text-base leading-7'}`} data-id="element-165">
              {story.quote}
            </blockquote>
            <figcaption className="mt-7 border-t border-[#d4af37]/18 pt-4" data-id="element-166">
              <p className="text-sm font-semibold text-ivory" data-id="element-167">{story.name}</p>
              <p className="mt-2 font-mono text-[10px] font-semibold uppercase tracking-[0.08em] text-gold" data-id="element-168">
                {story.result}
              </p>
            </figcaption>
          </figure>
        </Reveal>)}
    </div>;
}
export function EarlySocialProof() {
  return <section className="mx-auto max-w-6xl px-5 py-20 sm:px-8 sm:py-28" data-id="element-169">
      <Reveal data-id="element-170">
        <p className="mb-7 text-center font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-gold" data-id="element-171">
          Lo que dicen los que ya lo tienen
        </p>
      </Reveal>
      <TestimonialCards data-id="element-172" />
    </section>;
}
export function ProStories() {
  return <section className="px-5 py-20 sm:px-8 sm:py-28" data-id="element-173">
      <div className="mx-auto max-w-6xl" data-id="element-174">
        <Reveal className="mx-auto max-w-3xl text-center" data-id="element-175">
          <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-gold" data-id="element-176">
            Solo en la versión PRO
          </p>
          <h2 className="mt-5 font-display text-4xl font-bold leading-[0.98] tracking-[-0.04em] text-ivory sm:text-5xl" data-id="element-177">
            25 casos de{' '}
            <em className="font-normal text-gold" data-id="element-178">entrenadores reales</em>{' '}
            aplicando el sistema.
          </h2>
          <p className="mx-auto mt-5 max-w-2xl leading-7 text-sage" data-id="element-179">
            No testimonios genéricos. Casos documentados: qué hizo cada
            entrenador, en qué disciplina, con qué resultado.
          </p>
          <p className="mx-auto mt-7 inline-flex border border-gold bg-[#d4af37]/[0.05] px-3 py-2 font-mono text-[9px] font-semibold uppercase tracking-[0.1em] text-gold" data-id="element-180">
            Boxeo · Funcional · Crossfit · Pilates · Fútbol · Natación + más
          </p>
        </Reveal>
        <div className="mt-12" data-id="element-181">
          <TestimonialCards compact data-id="element-182" />
        </div>
        <Reveal className="mt-9 text-center" data-id="element-183">
          <p className="font-display text-3xl text-ivory" data-id="element-184">
            + 22 casos más, solo en la versión PRO
          </p>
          <a href="#pricing" className="mt-6 inline-flex min-h-11 items-center justify-center border border-gold px-5 font-mono text-[10px] font-bold uppercase tracking-wider text-gold transition-colors hover:bg-gold hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold" data-id="element-185">
            Ver versión PRO →
          </a>
        </Reveal>
      </div>
    </section>;
}